




















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { UserApi, User } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import SelectionDropdown from '@/components/Form/SelectionDropdown/index.vue';
import UserUtil from '@/util/UserUtil';
import Format from '@/util/Format';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    SelectionDropdown,
  },
})
export default class UsersList extends Vue {
  @Prop() public search!: string;

  @Prop() public searchRole!: any;

  @Prop() public searchStatus!: any;

  private userApi: any[] = [];

  private errors: string = '';

  private loading: boolean = false;

  private headers = [
    {
      text: 'User',
      align: 'left',
      value: 'userName',
      width: '350px',
    },
    {
      text: 'Role',
      align: 'left',
      value: 'userRole',
      width: '250px',
    },
    {
      text: 'Contact Number',
      align: 'left',
      value: 'email',
      width: '240px',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'disabled',
      width: '190px',
    },
  ];

  public mounted() {
    this.getAllUsers();
    if (this.$route.params.message) {
      ToastModule.setToast({
        message: this.$route.params.message,
        timeout: 2000,
      });
    }
  }

  get filteredItems() {
    let filteredUsers = this.userApi;
    if (this.search) {
      const query = this.search.toLowerCase();
      filteredUsers = filteredUsers.filter(
        user => (user.userName).toLowerCase()
          .includes(query)
        || (user.contactNumber || '')
          .toString()
          .includes(query)
        || ((user.disabled || '').toLowerCase())
          .includes(query.toLowerCase())
        || ((user.userFormatedRole).toLowerCase())
          .toLowerCase()
          .includes(query.toLowerCase()),
      );
    }
    if (this.searchRole && this.searchRole.length > 0) {
      filteredUsers = filteredUsers.filter(user => this.searchRole.includes(user.userRole));
    }
    if (this.searchStatus && this.searchStatus.length > 0) {
      filteredUsers = filteredUsers.filter(user => this.searchStatus.includes(user.disabled));
    }
    return filteredUsers;
  }

  public async getAllUsers() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new UserApi(AppModule.apiConfig);
          const users: any = await api.getUsers();
          this.userApi = UserUtil.getMappedUsers(users.data);
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public async onUpdateStatus(user: any, status: any) {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken && user) {
        const {
          userId, name, email, phone, userRole,
        } = user;

        const fwUser: User = {
          email,
          name,
          phone,
          id: userId,
          title: userRole,
          is: {
            disabled: status !== 'active',
          },
        };
        // try {
        //   await FwUserApi.updateUser(fwUser);
        // } catch (err) {
        //   throw err;
        // }
      }
    } catch (err) {
      throw err;
    }
  }
}
